<template>
  <div style="padding-top: 1rem">
    <!--<navTitle title="工单详情" path="/user/serve/msgList"></navTitle>-->
    <navTitle :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Message Details'
      " path="/user/serve/msgList"></navTitle>

    <div class="list">
      <div class="li">
        <div class="time">Submission time:{{ time }}</div>
        <div class="time">Message content:</div>
        <div class="msg">{{ question }}</div>
        <template v-if="answer">
          <div class="time">Replied:</div>
          <div class="time">Replied time:{{ answer_time }}</div>
          <div class="comment">{{ answer }}</div>
        </template>
        <template v-else>
          <div class="time">Working status:Processing</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import navTitle from "@components/navTitle";
  import { message_detail } from "@api/user";

  export default {
    name: "newsList",
    components: {
      navTitle
    },
    data: function () {
      return {
        question: "",
        answer: "",
        time: "",
        answer_time: ""
      };
    },
    methods: {
      get() {
        this.$dialog.loading.open("Loading...");
        message_detail(this.$route.query.id)
          .then(res => {
            this.question = res.data.message;
            this.time = res.data.add_time;
            this.answer = res.data.answer;
            this.answer_time = res.data.answer_time;
            this.$dialog.loading.close();
          })
          .catch(res => {
            this.$dialog.loading.close();
            this.$dialog.error(res.msg);
          });
      }
    },
    mounted() {
      this.get();
    }
  };
</script>

<style scoped>
  .list {
    width: 100%;
    /*background: #fff;*/
    padding-bottom: 1.4rem;
    padding-top: 0.3rem;
  }

  .li {
    width: 100%;
    padding: 0.3rem;
    box-sizing: border-box;
    min-height: 1rem;
    background: #fff;
    margin-bottom: 0.3rem;
  }

  .time {
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    background: #fff;
    color: #666;
  }

  .comment {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }

  .msg {
    width: 100%;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.25rem;
    margin-bottom: 0.25rem;
  }
</style>